import { ScrollView } from 'react-native';
import { Flex, Typography } from '@banhala/ui-kit';
import type { RankingFilterCategory } from 'shared/src/api';

interface SubCategoryFilterProps {
  subCategories: RankingFilterCategory[];
  selectedSno: number | null;
  onSelect: (category: RankingFilterCategory) => void;
}

export const SubCategoryFilter = ({
  subCategories,
  selectedSno,
  onSelect,
}: SubCategoryFilterProps) => {
  if (subCategories.length === 0) return null;

  return (
    <Flex backgroundColor="bg_secondary">
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ paddingHorizontal: 6 }}
      >
        <Flex.Row>
          {subCategories.map(category => {
            const isSelected = category.sno === selectedSno;
            return (
              <Flex
                key={category.sno}
                padding={{ vertical: 12, horizontal: 8 }}
                onPress={() => onSelect(category)}
              >
                <Typography
                  type={isSelected ? 'subtitle2' : 'body2'}
                  color={isSelected ? 'content_primary' : 'content_secondary'}
                >
                  {category.name}
                </Typography>
              </Flex>
            );
          })}
        </Flex.Row>
      </ScrollView>
    </Flex>
  );
};
